module.exports = __webpack_public_path__ + "img/wompi.be5dce95.svg";